export default "__VITE_ASSET__DoNdRNYm__"